import { createSelector } from 'reselect';
import { toSelector } from '@zedoc/selectors';
import ProjectDraftEditLock from '../models/ProjectDraftEditLock';
import createSelectors from './createSelectors';

const Select = createSelectors(ProjectDraftEditLock, {
  whereProjectIdEquals: (getProjectId) => (select) =>
    select.where(
      createSelector(
        toSelector(getProjectId),
        (projectId) => (doc) => !!projectId && doc.projectId === projectId,
      ),
    ),
});

export default Select;
